/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { MultiplicationSignStrokeStandard } from "@hugeicons-pro/core-stroke-standard";
//@ts-ignore
import { HugeiconsIcon } from "@hugeicons/react";
import ReactGanttChart from "./BulkEmailGanttChart"; // Import the shared component

interface ReactGanttPopupProps {
  open: boolean;
  onClose: () => void;
}

const ReactGanttPopup = ({ open, onClose }: ReactGanttPopupProps): JSX.Element => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl" >
     
       
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
            icon={MultiplicationSignStrokeStandard}
            size={24}
            color="currentcolor"
            strokeWidth={0.5}
          />
        </IconButton>
    

      <DialogContent>
        {/* Use the shared Gantt chart component */}
        <ReactGanttChart />
      </DialogContent>
    </Dialog>
  );
};

export default ReactGanttPopup;